import React from 'react'
import { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH, NAV_TYPE_TOP } from 'constants/ThemeConstant';
import {APP_NAME} from 'configs/AppConfig';
import { connect } from "react-redux";
import utils from 'utils';
import { Grid } from 'antd';
import ThemeService from "../../services/ThemeService";

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
  const { navCollapsed, navType } = props;
  const isNavTop = navType === NAV_TYPE_TOP
  if(isMobile && !props.mobileLogo) {
    return 0
  }
  if(isNavTop) {
    return 'auto'
  }
  if(navCollapsed) {
    return `${SIDE_NAV_COLLAPSED_WIDTH}px`
  } else {
    return `${SIDE_NAV_WIDTH}px`
  }
}

const getLogo = (props) => {
  const { navCollapsed, logoType } = props;

  const dynamicLogo = ThemeService.getLogoUrl();

  if (dynamicLogo) {
    return dynamicLogo;
  }

  if(logoType === 'light') {
    if(navCollapsed) {
      return `/img/logo-sm-white.png`
    }
    return `/img/logo-white.png`
  }

  if (navCollapsed) {
    return `/img/logo-sm.png`
  }
  return `/img/logo.png`
}

const getLogoDisplay = (isMobile, mobileLogo) => {
  if(isMobile && !mobileLogo) {
    return 'd-none'
  } else {
    return 'logo'
  }
}

export const Logo = (props) => {
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg');

  const { navCollapsed } = props;

  const logoStyles = {
    width: '100%',
    height: '100%',
    padding: navCollapsed ? '0' : '10px 20px',
    objectFit: 'contain',
    transition: 'all 0.3s ease',
    maxHeight: '70px',
  };

  const containerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: getLogoWidthGutter(props, isMobile),
    height: '70px',
    overflow: 'hidden',
    transition: 'width 0.3s ease'
  };

  return (
    <div
      className={getLogoDisplay(isMobile, props.mobileLogo)}
      style={containerStyles}
    >
      <img
        src={getLogo(props)}
        alt={`${APP_NAME} logo`}
        style={logoStyles}
      />
    </div>
  );
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType } =  theme;
  return { navCollapsed, navType }
};

export default connect(mapStateToProps)(Logo);
